enum popups {
	Upload = 'upload',
	Favorite = 'favorite',
	Setup = 'setup',
	Delete = 'delete',
}

const popupText = {
	[popups.Upload]: 'Загрузить в сеть',
	[popups.Favorite]: 'Добавить в избранное',
	[popups.Setup]: 'Установить',
	[popups.Delete]: 'Удалить настройку',
};

const popupPosition = {
	[popups.Upload]: 140,
	[popups.Favorite]: 85,
	[popups.Setup]: 40,
	[popups.Delete]: -25,
};

export { popups, popupText, popupPosition };
